import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

// Sider
import Forside from './pages/Forside';
import Eventet from './pages/Eventet';
import Billetter from './pages/Billetter';
import GodtFormaal from './pages/GodtFormaal';
import Partnere from './pages/Partnere';
import OmOs from './pages/OmOs';
import OrBike365 from './pages/OrBike365';
import PraktiskInfo from './pages/PraktiskInfo';
import PriorityCykler from './pages/PriorityCykler';
import Fotoarkiv from './pages/Fotoarkiv';
import Regnskaber from './pages/Regnskaber';
import Kontakt from './pages/Kontakt';
import Butik from './pages/Butik';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#090a0f] text-slate-100 font-sans selection:bg-pink-500 selection:text-white">
        <ScrollToTop />
        <Header />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/eventet" element={<Eventet />} />
            <Route path="/orbike-eventet" element={<Navigate to="/eventet" replace />} />
            
            <Route path="/billetter" element={<Billetter />} />
            
            <Route path="/godt-formaal" element={<GodtFormaal />} />
            <Route path="/for-born-med-kritisk-sygdom" element={<Navigate to="/godt-formaal" replace />} />
            
            <Route path="/partnere" element={<Partnere />} />
            
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/om-orbike" element={<Navigate to="/om-os" replace />} />
            
            <Route path="/orbike-365" element={<OrBike365 />} />
            <Route path="/oerbike-365" element={<Navigate to="/orbike-365" replace />} />
            <Route path="/365" element={<Navigate to="/orbike-365" replace />} />
            
            <Route path="/praktisk-info" element={<PraktiskInfo />} />
            <Route path="/faqs" element={<Navigate to="/praktisk-info" replace />} />
            
            <Route path="/priority-cykler" element={<PriorityCykler />} />
            <Route path="/fotoarkiv" element={<Fotoarkiv />} />
            <Route path="/regnskaber" element={<Regnskaber />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/butik" element={<Butik />} />
            <Route path="/shop" element={<Navigate to="/butik" replace />} />
            
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <FloatingCTA />
        <Footer />
      </div>
    </HelmetProvider>
  );
}
